// extracted by mini-css-extract-plugin
module.exports = {"title":"category-details_title_24STi","retailer":"category-details_retailer_11eey"};